import './ui/style.css'
import { Game } from '@/game/Game'

const canvas = document.getElementById('viewport') as HTMLCanvasElement | null
const uiRoot = document.getElementById('ui-root')

if (!canvas || !uiRoot) {
  throw new Error('VOIDFALL: #viewport or #ui-root missing from index.html')
}

const game = new Game(canvas, uiRoot)
game.start()

// Exposed in dev for the console and for the headless screenshot harness
// (`npm run shotcheck`), which poses situations and grabs frames.
if (import.meta.env.DEV) {
  const api = game.testApi()
  Object.assign(window, { game, VOIDFALL: api })
}
